import { defineMessages } from "react-intl";

export default defineMessages({
  openApp: {
    id: "+FWlRD",
    defaultMessage: "Open app",
    description: "button",
  },
  supportLink: {
    id: "Nsk5WL",
    defaultMessage: "Get support",
    description: "link",
  },
  aboutAppTitle: {
    id: "jDIRQV",
    defaultMessage: "About this app",
    description: "section header",
  },
  appPermissionsTitle: {
    id: "VsGcdP",
    defaultMessage: "App permissions",
    description: "section header",
  },
  appPermissionsDescription: {
    id: "7oQUMG",
    defaultMessage: "This app has permissions to:",
    description: "apps about permissions",
  },
  dataPrivacyTitle: {
    id: "a55zOn",
    defaultMessage: "Data privacy",
    description: "section header",
  },
  dataPrivacyDescription: {
    id: "Go50v2",
    defaultMessage: "View this app’s privacy policy",
    description: "app privacy policy link",
  },
});
